import { SpaceXxs, ColorTextDefault, SizeIconSvgSm, ColorGray900, SpaceMd } from "@nxt-costco-com/forge-design-tokens";
const checkmarkStyle = {
  color: ColorGray900,
  height: `${SizeIconSvgSm}`,
  width: `${SizeIconSvgSm}`
};
const buttonStyle = {
  "& .MuiButton-startIcon": {
    margin: 0
  },
  "&:hover": {
    textDecoration: `underline ${ColorTextDefault}`
  },
  alignItems: "flex-start",
  gap: `${SpaceXxs}`
};
const headerStyle = {
  marginTop: `${SpaceMd}`
};
export {
  buttonStyle,
  checkmarkStyle,
  headerStyle
};
